/* Map Modul */
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define("Map", ['jquery', 'lazyloadmap'], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory(require('jquery'), require('lazyloadmap'));
    } else {
        // Browser globals (root is window)
        root.returnExports = factory(root.jquery, root.lazyLoadGoogleMaps);
    }
}(typeof self !== 'undefined' ? self : this, function ($, lazyLoadGoogleMaps) {

    var map = (function ($) {
        'use strict';

        var moduleClass = "#g-map";
        var mapInstances = []; // map példányok tömbje
        var pluginInstance = null; // lazyload példány
        var mapIcon = null;

        var path = "https://www.google.hu/maps/place/Hark%C3%A1nyi+Gy%C3%B3gyf%C3%BCrd%C5%91+Zrt./@45.8527318,18.2404037,15z/data=!4m5!3m4!1s0x0:0x6b244954ff2c1ea!8m2!3d45.8527318!4d18.2404037";

        if (window.serverVariables) {
            mapIcon = window.mapIcon || null;
        }

        var mapStyle = [{
                "featureType": "administrative.locality",
                "elementType": "all",
                "stylers": [
                    {
                        "hue": "#2c2e33"
                    },
                    {
                        "saturation": 7
                    },
                    {
                        "lightness": 19
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 100
                    },
                    {
                        "visibility": "simplified"
                    },
                    {
                        "color": "#3fa5ac"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "saturation": "2"
                    },
                    {
                        "lightness": "-100"
                    },
                    {
                        "gamma": "0.00"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "lightness": "-100"
                    },
                    {
                        "saturation": "-100"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "hue": "#ffffff"
                    },
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 100
                    },
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {
                        "saturation": "-100"
                    },
                    {
                        "lightness": "31"
                    },
                    {
                        "visibility": "on"
                    },
                    {
                        "weight": "1"
                    },
                    {
                        "color": "#276b6f"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels",
                "stylers": [
                    {
                        "saturation": -93
                    },
                    {
                        "lightness": "-61"
                    },
                    {
                        "visibility": "on"
                    },
                    {
                        "weight": "0.74"
                    },
                    {
                        "gamma": "0.00"
                    },
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels",
                "stylers": [
                    {
                        "hue": "#bbc0c4"
                    },
                    {
                        "saturation": -93
                    },
                    {
                        "lightness": -2
                    },
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [
                    {
                        "hue": "#e9ebed"
                    },
                    {
                        "saturation": -90
                    },
                    {
                        "lightness": -8
                    },
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "hue": "#e9ebed"
                    },
                    {
                        "saturation": 10
                    },
                    {
                        "lightness": 69
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "hue": "#e9ebed"
                    },
                    {
                        "saturation": -78
                    },
                    {
                        "lightness": 67
                    },
                    {
                        "visibility": "simplified"
                    }
                ]
        }];

        var isMobile = function () {
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true;
            }
            return false;
        };

        var hasMapOnPage = function () {
            if ($(moduleClass).length) {
                return true;
            }
            return false;
        }

        var setup = function () {
            pluginInstance = $(moduleClass).lazyLoadGoogleMaps({
                key: $(moduleClass).data('key'),
                callback: function (container, map) {
                    var isDraggable = !isMobile();

                    google.maps.Map.prototype.setCenterWithOffset= function(latlng, offsetX, offsetY) {
                        var map = this;
                        var ov = new google.maps.OverlayView();
                        ov.onAdd = function() {
                            var proj = this.getProjection();
                            var aPoint = proj.fromLatLngToContainerPixel(latlng);
                            aPoint.x = aPoint.x+offsetX;
                            aPoint.y = aPoint.y+offsetY;
                            map.setCenter(proj.fromContainerPixelToLatLng(aPoint));
                        }; 
                        ov.draw = function() {}; 
                        ov.setMap(this); 
                    };

                    var $container = $(container),
                        center = new google.maps.LatLng($container.attr('data-lat'), $container.attr('data-lng'));

                    var mapOptions = {
                        center: center,
                        mapTypeId: google.maps.MapTypeId.ROADMAP,
                        mapTypeControl: false,
                        streetViewControl: false,
                        zoom: 16,
                        scrollwheel: false,
                        zoomControl: false,
                        styles: mapStyle,
                        draggable: isDraggable
                    };

                    var map = new google.maps.Map(document.getElementById("g-map"),
                        mapOptions);
                
                    if (isMobile()) {
                        map.setCenterWithOffset(center, -50, -10);
                    } else {
                        map.setCenterWithOffset(center, -370, 10);
                    }
                 
                    //$.data(map, 'center', center);
                    mapInstances.push(map);

                    var marker = null;
                    if (mapIcon !== null) {
                        marker = new google.maps.Marker({
                            position: center,
                            map: map,
                            icon: mapIcon,
                            optimized: false
                        });
                    } else {
                        marker = new google.maps.Marker({
                            position: center,
                            map: map,
                            optimized: false
                        });
                    }

                    var address = $(moduleClass).data('address');
                    var infowindow = new google.maps.InfoWindow({
                        content: "<strong>" + address + "</strong>"
                    });

                    marker.addListener('click', function () {
                        window.open(
                            path,
                            '_blank'
                          );
                    });
                }
            });
        }

        var init = function () {
            if (hasMapOnPage()) {
                setup();
            }
        };

        return {
            init: init
        };
    })(jQuery);

    return map;
}));


//////////////////
// WEBPACK FOOTER
// ./js/modules/map/index.js
// module id = 25
// module chunks = 2